import React from "react";

function Sessions() {
  const sessions = [
    {
      day: "Wednesday",
      time: "6:30pm-8:30pm",
      courts: "3 courts",
      audience: "Open session",
    },
    {
      day: "Sunday",
      time: "9:00am-10:30am",
      courts: "1 court",
      audience: "Female only",
    },
    {
      day: "Sunday",
      time: "10:30am-12:30pm",
      courts: "3 courts",
      audience: "Open session",
    },
    {
      day: "Sunday",
      time: "9:00am-10:30am",
      courts: "2 courts",
      audience: "Junior development program",
    },
  ];

  return (
    <div className="container">
      <h2 className="section-title">Session & Venue Details</h2>
      <div className="sessions-modern">
        <div className="sessions-modern-header">
          <p className="sessions-modern-kicker">Weekly schedule</p>
          <div className="sessions-modern-pills" aria-label="Session highlights">
            <span>4 sessions</span>
            <span>Women-focused Sunday slot</span>
            <span>Junior pathway</span>
          </div>
        </div>

        <div className="sessions-modern-grid">
          {sessions.map((session) => (
            <article className="sessions-modern-card" key={`${session.day}-${session.time}`}>
              <div className="sessions-modern-top">
                <p className="sessions-modern-day">{session.day}</p>
                <span
                  className={`sessions-modern-tag ${
                    session.audience === "Female only"
                      ? "sessions-modern-tag-female"
                      : session.audience === "Junior development program"
                        ? "sessions-modern-tag-junior"
                        : ""
                  }`}
                >
                  {session.audience}
                </span>
              </div>

              <h3 className="sessions-modern-time">{session.time}</h3>
              <ul className="sessions-modern-meta">
                <li>
                  <strong>Courts:</strong> {session.courts}
                </li>
                <li>
                  <strong>Venue:</strong> Lake Haven Recreation Centre, Forrow Dr, Lake Haven NSW
                  2263
                </li>
              </ul>
            </article>
          ))}
        </div>
      </div>

      <p className="muted sessions-modern-note">
        We run friendly, well‑organised social sessions giving players a consistent and enjoyable
        place to play all year round.
      </p>
    </div>
  );
}

export default Sessions;
